import { render } from "./SocialMediaLinksPage.vue?vue&type=template&id=3b7cf07c&scoped=true"
import script from "./SocialMediaLinksPage.vue?vue&type=script&lang=js"
export * from "./SocialMediaLinksPage.vue?vue&type=script&lang=js"

import "./SocialMediaLinksPage.vue?vue&type=style&index=0&id=3b7cf07c&scoped=true&lang=css"

import exportComponent from "C:\\Projekte\\repos\\datentool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7cf07c"]])

export default __exports__